import Skeleton from "@mui/material/Skeleton";
import Stack from "@mui/material/Stack";
import { memo } from "react";

/**
 * What the content column shows while a page's code is on its way.
 *
 * Every page is loaded on first visit, so each layout's Suspense needs a
 * fallback: without one the header and menu stood over an empty column until
 * the chunk arrived, which on a slow connection read as a click that did
 * nothing. This is the shape of a page, not the full-screen loading clouds,
 * which would cover the header too.
 */
const PageFallback = () => (
  <Stack
    role="status"
    aria-busy="true"
    sx={{ p: { xs: 2, md: 5 }, gap: 3, maxWidth: 1400, mx: "auto", width: "100%" }}
  >
    <Skeleton variant="rounded" sx={{ height: { xs: 140, md: 220 }, borderRadius: 3 }} />
    <Skeleton variant="text" width="30%" sx={{ fontSize: "1.75rem" }} />
    <Stack direction="row" gap={2}>
      {[0, 1, 2, 3].map((item) => (
        <Skeleton
          key={item}
          variant="rounded"
          sx={{
            flex: 1,
            height: { xs: 150, md: 210 },
            borderRadius: 3,
            display: { xs: item > 1 ? "none" : "block", md: "block" },
          }}
        />
      ))}
    </Stack>
  </Stack>
);

export default memo(PageFallback);
